<template>
    <tiny-editor ref="tinyEditorRef" v-model="localValue" @update:modelValue="emitModel" :height="height"></tiny-editor>
</template>

<script lang="ts">
import WithModel from '@/mixins/withModel';
import { mixins, Options } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Options({})
export default class rteEditor extends mixins(WithModel) {

    @Prop() height: number;

    insertContent(html: string) {
        (this.$refs.tinyEditorRef as any).insertContent(html);
    }

    @Watch('modelValue')
    ensureIsString(){
        if(!this.modelValue){
            this.localValue = "";
        }
    }

}

</script>
<style scoped>

</style>
